export default "__VITE_ASSET__bdae8140__"